import React from 'react'

function ContactSucces() {
    return (
        <div style={{ color: "white", padding: "40px", textAlign: "center" }}>
            <h1 style={{ marginTop: '40px', color: 'green' }}>Mesaj trimis cu succes!</h1>
            <p>Îți mulțumim pentru mesaj. Te vom contacta în cel mai scurt timp.</p>
        </div>
    );
}

export default ContactSucces